
import React from 'react';

export const BlogHeader = () => {
  return (
    <div className="mb-12">
      <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
        Blog
      </h1>
      <p className="text-muted-foreground">
        Approfondimenti, guide e consigli sul mondo dell'oro e dei metalli preziosi
      </p>
    </div>
  );
};
